@if (item) {
    @if (item!.link?.href$ | async; as href) {
        @if (isInternal) {
            <a [id]="item!.id || ''"
               [routerLink]="href"
               [attr.title]="item!.tooltip ? item!.tooltip : null"
               (click)="togglePopover($event)">
                @if (item?.linkContent) {
                    <adapt-render-component [component]="item!.linkContent!.component"
                                            [componentInputs]="item!.linkContent!.params"></adapt-render-component>
                }
            </a>
        } @else {
            <a [id]="item!.id || ''"
               [attr.href]="href || '#'"
               [attr.target]="item!.link?.openInNewTab ? '_blank' : null"
               [attr.rel]="item!.link?.openInNewTab ? 'noreferrer noopener' : null"
               [adaptTooltip]="item!.tooltip ? item!.tooltip : null"
               tooltipPlacement="right"
               (click)="togglePopover($event)">
                @if (item?.linkContent) {
                    <adapt-render-component [component]="item!.linkContent!.component"
                                            [componentInputs]="item!.linkContent!.params"></adapt-render-component>
                }
            </a>
        }
    } @else {
        <a [id]="item!.id || ''"
           [attr.title]="item!.tooltip ? item!.tooltip : null"
           [ngStyle]="{ cursor: 'pointer' }"
           (click)="togglePopover($event)">
            @if (item?.linkContent) {
                <adapt-render-component [component]="item!.linkContent!.component"
                                        [componentInputs]="item!.linkContent!.params"></adapt-render-component>
            }
        </a>
    }
    <!-- Angular 12 does not support setting routerLink to null|undefined. we can revert this once we upgrade to 13. -->
    <!-- Without deferRendering=false the popover, the first display of it goes off screen -->
    @if (item!.popover) {
        <dx-popover (onContentReady)="onPopoverContentReady($event)"
                    [target]="target"
                    [visible]="popoverVisible$ | async"
                    (visibleChange)="onPopoverVisibleChanged($event)"
                    [deferRendering]="false"
                    [position]="popoverLocation">
            <adapt-render-component *dxTemplate="let model of 'content'"
                                    [component]="item!.popover!.component"
                                    [componentInputs]="item!.popover!.params"
                                    (componentRendered)="onPopoverContentRendered($event)"></adapt-render-component>
        </dx-popover>
    }
}
